import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-24 md:py-40">
      <p className="text-xs uppercase tracking-[0.3em] text-gold font-stats">
        404 — Page introuvable
      </p>
      <h1 className="mt-6 font-display font-black text-6xl md:text-9xl leading-none text-white">
        RIEN ICI
      </h1>
      <p className="mt-6 max-w-xl text-neutral-400">
        La page que vous cherchez n'existe pas ou a été déplacée. Retournez à
        l'accueil pour retrouver le prochain événement.
      </p>
      <Link
        to="/"
        data-testid="notfound-home-link"
        className="inline-flex items-center gap-3 mt-10 px-6 py-3 border border-white text-white font-display uppercase tracking-widest text-sm hover:bg-white hover:text-black transition-colors duration-200"
      >
        Retour à l'accueil →
      </Link>
    </section>
  );
}
